const mediaItems = [
  {
    title: '漫画推荐：这个夏天必看的十部热血全本漫画',
    desc: '精选十部燃到爆炸的热血全本漫画推荐，从经典到新作，每一部都是完整版免费阅读，下拉式体验极致畅快。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20manga%20recommendation%20thumbnail%20style%20with%20dynamic%20action%20composition%2C%20warm%20coral%20accent%20tone%2C%20adventure%20theme%2C%20bold%20typography%20friendly%20layout%2C%20energetic%20atmosphere%2C%20YouTube%20thumbnail%20style&width=640&height=360&seq=media-01&orientation=landscape',
    icon: 'ri-fire-line',
  },
  {
    title: '新手指南：下拉式阅读的正确打开方式',
    desc: '从如何选择漫画到畅享下拉式阅读，樱花漫画网使用全攻略，帮助新读者快速上手，享受全集免费阅读体验。',
    image: 'https://readdy.ai/api/search-image?query=Educational%20tutorial%20style%20illustration%20with%20soft%20warm%20lighting%2C%20clean%20modern%20design%2C%20guide%20theme%2C%20amber%20and%20cream%20color%20palette%2C%20friendly%20approachable%20atmosphere%2C%20minimalist%20composition&width=640&height=360&seq=media-02&orientation=landscape',
    icon: 'ri-guide-line',
  },
  {
    title: '韩漫vs日漫：两种风格的碰撞与融合',
    desc: '深度解析韩漫精致画风与日漫叙事传统的异同，带你了解两种漫画文化的独特魅力，找到最适合你的全本漫画类型。',
    image: 'https://readdy.ai/api/search-image?query=Comparison%20style%20split%20screen%20illustration%20with%20Korean%20and%20Japanese%20manga%20art%20styles%20side%20by%20side%2C%20warm%20rose%20gold%20and%20coral%20gradient%2C%20artistic%20analysis%20theme%2C%20clean%20editorial%20design%2C%20balanced%20composition&width=640&height=360&seq=media-03&orientation=landscape',
    icon: 'ri-contrast-2-line',
  },
  {
    title: '国漫蜕变之路：从小众到主流的崛起',
    desc: '回顾国漫近年来的发展历程，从优秀作品出发看国漫如何一步步赢得读者认可，全本漫画免费完整版助力国漫传播。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20painting%20transformation%20into%20modern%20digital%20art%20illustration%2C%20warm%20golden%20and%20coral%20color%20transition%2C%20evolution%20theme%2C%20elegant%20artistic%20atmosphere%2C%20cultural%20heritage%20vibe%2C%20clean%20editorial%20layout&width=640&height=360&seq=media-04&orientation=landscape',
    icon: 'ri-flag-line',
  },
  {
    title: '编辑部精选：本周最受欢迎漫画TOP5',
    desc: '樱花漫画网编辑部根据阅读数据精选本周最受欢迎的五部全本漫画作品，韩漫日漫国漫各类型全面覆盖，一次看个够。',
    image: 'https://readdy.ai/api/search-image?query=Editor%20pick%20style%20collage%20illustration%20with%20manga%20elements%20and%20ranking%20design%2C%20warm%20amber%20and%20coral%20gradient%20background%2C%20curated%20selection%20theme%2C%20professional%20editorial%20look%2C%20clean%20modern%20composition&width=640&height=360&seq=media-05&orientation=landscape',
    icon: 'ri-star-line',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-4">
          精彩推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精选漫画推荐文章与专题内容，发现更多好看的全本漫画
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 w-10 h-10 flex items-center justify-center bg-primary-500 rounded-full">
                  <i className={`${item.icon} text-background-50 text-base`}></i>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-medium text-foreground-900 text-sm md:text-base mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}